module.exports = __webpack_public_path__ + "static/media/NoirPro-Regular.fe706631.woff2";